export default __webpack_public_path__ + "static/media/altehaasgroteskregular.6ae6623e.ttf";